import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  url = url;
  displayQuickMenu: boolean = false;

  showQuickMenu() {
    this.displayQuickMenu = true;
  }

  hideQuickMenu() {
    this.displayQuickMenu = false;
  }

  getUrl(filter: string): string {
    return '/' + url['lista-perfiles'] + '/' + filter;
  }

}
